<template>
  <div class="flex items-center gap-3 p-3 bg-nera-ai-msg border border-nera-border rounded-lg transition-colors hover:bg-nera-light-hover">
    <span class="text-2xl text-nera-success">
      <i :class="fileIconClass"></i>
    </span>
    <div class="flex-1 flex flex-col">
      <span class="font-medium text-nera-text">{{ file.name }}</span>
      <span class="text-sm text-nera-muted">{{ formatSize(file.size) }}</span>
    </div>
    <button
      @click="$emit('remove')"
      title="Remove file"
      aria-label="Remove file"
      class="w-5 h-5 inline-flex items-center justify-center rounded-full bg-black/30 text-nera-text transition-colors hover:bg-black/50"
    >
      <i class="fas fa-times text-xs"></i>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  file: {
    type: Object,
    required: true
  }
})

defineEmits(['remove'])

const fileIconClass = computed(() => {
  if (props.file.type?.includes('csv')) return 'fas fa-file-csv'
  if (props.file.type?.includes('excel') || props.file.type?.includes('spreadsheet')) {
    return 'fas fa-file-excel'
  }
  return 'fas fa-file'
})

const formatSize = (bytes) => {
  if (bytes < 1024) return bytes + ' B'
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
}
</script>
